import { useState } from "react";
import { BaseButton, BaseInput } from "../../components/base";
import { useNotification } from "../../context/NotificationProvider";
import { Box, Typography, InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { setPassword } from "../../api/auth/authAPI";
import logo from "../../assets/images/hashinLogoLight.png";
import URIs from "../../utils/uri";
import useProtectedClient from "../../hooks/useProtectedClient";
import { hashPassword } from "../../utils/helpers";

const SetPassword = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [passwordValue, setPasswordValue] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordStrength, setPasswordStrength] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const { showNotification } = useNotification();
    const protectedClient = useProtectedClient();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const hashedPassword = hashPassword(passwordValue);
            await setPassword(protectedClient, hashedPassword);
            navigate(URIs.KYC);
        } catch (error) {
            showNotification(error, "error");
        } finally {
            setIsLoading(false);
        }
    };

    

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPasswordValue(value);

        // Password strength regex
        if (/[\u0600-\u06FF]/.test(value)) {
            setPasswordStrength("نمیتواند شامل حروف فارسی باشد.");
        } else if (value.length < 8) {
            setPasswordStrength("باید حداقل 8 کاراکتر باشد.");
        } else if (!/[A-Z]/.test(value)) {
            setPasswordStrength("یک حرف بزرگ اضافه کنید.");
        } else if (!/[a-z]/.test(value)) {
            setPasswordStrength("یک حرف کوچک اضافه کنید.");
        } else if (!/[0-9]/.test(value)) {
            setPasswordStrength("یک عدد اضافه کنید.");
        } else if (!/[!@#$%^&*]/.test(value)) {
            setPasswordStrength("یک کاراکتر خاص مانند @ یا ! اضافه کنید.");
        } else {
            setPasswordStrength("مورد قبول است");
        }
        
        if (confirmPassword === value) {
            setPasswordConfirmation(true)
        } else {
            setPasswordConfirmation(false)
        } 
    };

    const handlePasswordConfirm = (e) => {
        const value = e.target.value;
        setConfirmPassword(value);

        if (passwordValue === value) {
            setPasswordConfirmation(true)
        } else {
            setPasswordConfirmation(false)
        }   
    };

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="center"
            padding={2}
            gap={4}
            sx={{ height: "100vh", paddingTop: "80px" }}
        >
            <img src={logo} alt="Logo" style={{ width: "120px" }} />
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={2}>
                <Typography variant="caption" sx={{ textAlign: "center", width: "90%", maxWidth: 400 }}>
                    لطفا یک رمز برای امنیت خود قرار دهید
                </Typography>
                <Typography variant="subtitle" sx={{ textAlign: "center", width: "90%", maxWidth: 400 }}>
                    رمز باید حداقل ۸ کاراکتر و شامل حرف انگلیسی بزرگ، کوچک، عدد و کاراکتر خاص باشد.
                </Typography>
            </Box>
            <form onSubmit={handleSubmit} style={{ width: "90%", maxWidth: 400 }}>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="stretch"
                    gap={2}
                >
                    {/* <BaseInput
                        label="شماره موبایل"
                        value={phone}
                        name="username"
                        type="text"
                        autoComplete="username"
                        disabled
                    /> */}
                    <BaseInput
                        label="رمز جدید"
                        value={passwordValue}
                        onChange={handlePasswordChange}
                        name="password"
                        type={showPassword ? "text" : "password"}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                <IconButton
                                    onClick={handleTogglePasswordVisibility}
                                    edge="end"
                                    aria-label="toggle password visibility"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility /> }
                                </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Typography variant="subtitle"
                        color={passwordStrength === "مورد قبول است" ? "success" : "error"}
                    >
                        {passwordStrength}
                    </Typography>
                    <BaseInput
                        label="تایید رمز"
                        value={confirmPassword}
                        onChange={handlePasswordConfirm}
                        name="confirm-password"
                        type={showPassword ? "text" : "password"}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                <IconButton
                                    onClick={handleTogglePasswordVisibility}
                                    edge="end"
                                    aria-label="toggle password visibility"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility /> }
                                </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Typography variant="subtitle"
                        color={passwordConfirmation ? "success" : "error"}
                    >
                        {passwordStrength === "مورد قبول است" ? (passwordConfirmation ? 'رمزها یکسان هستند' : 'دقیقا رمز بالایی را تکرار  کنید') : ""}
                    </Typography>
                    <BaseButton type="submit" isLoading={isLoading} disabled={!passwordConfirmation}>
                        تایید
                    </BaseButton>
                </Box>
            </form>
        </Box>
    );
};

export default SetPassword;
